import React from 'react';
import { ButtonModal } from '../styled';
import { ReactComponent as DoneIcon } from '../images/done.svg';

const Modal = ({
  isCopied,
  onClick,
  children,
}: {
  isCopied: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => {
  return (
    <>
      {children}
      {isCopied ? (
        <ButtonModal color={'light_violet'} onClick={onClick}>
          <DoneIcon /> <span style={{ marginLeft: '8px' }}>скопировано</span>
        </ButtonModal>
      ) : (
        <ButtonModal color={'violet'} onClick={onClick}>
          cкопировать
        </ButtonModal>
      )}
    </>
  );
};

export default Modal;
